const patientDetailsDrawerBody = {
  // Chrome copy for the shared presentational drawer shell. The drawer is
  // titled "Patient quick-look" across all surfaces (matches Figma); the
  // loading/error/empty copy is reused by every data wrapper (clinic, admin).
  drawer: {
    title: "Patient quick-look",
    loadingLabel: "Loading patient details",
    loadError: "We couldn't load patient details. Please try again.",
    emptyState: "No patient details found.",
  },
  sectionTitles: {
    biometrics: "Biometrics",
    patientSurveys: "Patient Surveys",
    goals: "Goals",
    conditions: "Conditions",
    symptoms: "Symptoms",
    currentlyTaking: "Currently taking",
    medications: "Medications",
    womensHormones: "Women's hormones",
  },
  womensHormones: {
    menopauseStatus: "Current menopause status",
    periodStatus: "Current period status",
    appointmentDate: "Appointment date",
    menstrualCyclePhase: "Menstrual cycle phase",
    suggestedDates: "Suggested test dates",
  },
  differentials: {
    summaryPill: "{{count}} change since {{cycleLabel}}",
    summaryPill_plural: "{{count}} changes since {{cycleLabel}}",
    cycleLabel: {
      one: "{{cycle}}st test cycle",
      two: "{{cycle}}nd test cycle",
      few: "{{cycle}}rd test cycle",
      other: "{{cycle}}th test cycle",
    },
    symptomValue: "{{value}} / 5",
    symptomPriorValue: "was {{value}} / 5",
    symptomNoChange: "No change",
    weightPriorNote: "was {{value}}",
    groupTitles: {
      newSinceLastTest: "New since last test",
      resolved: "Resolved",
    },
    badges: {
      new: "New",
      resolved: "Resolved",
      better: "Better",
      worse: "Worse",
    },
  },
  viewSurveysButton: "View surveys",
  emptyDemographicsFallback: "No demographics provided",
  emptyCurrentlyTakingDetailsFallback: "No brand or dosage provided",
} as const;

export { patientDetailsDrawerBody };
